import { render, staticRenderFns } from "./ManageResourceTags.modal.vue?vue&type=template&id=03feac05"
import script from "./ManageResourceTags.modal.vue?vue&type=script&lang=ts"
export * from "./ManageResourceTags.modal.vue?vue&type=script&lang=ts"
import style0 from "./ManageResourceTags.modal.vue?vue&type=style&index=0&id=03feac05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports